export default "skymp5-front/82617ff7e70f070a9bb74e948d25047e.png";